import { useState, useEffect } from 'react';

const STORAGE_KEY = 'bsp-sidebar-width';

export const useResizableSidebar = (
  initialWidth = 220,
  minWidth = 150,
  maxWidth = 400
) => {
  const [width, setWidth] = useState<number>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsedWidth = parseInt(saved, 10);
      return Math.max(minWidth, Math.min(maxWidth, parsedWidth));
    }
    return initialWidth;
  });

  const [isResizing, setIsResizing] = useState(false);

  const handleMouseDown = () => {
    setIsResizing(true);
  };

  useEffect(() => {
    if (!isResizing) return;

    document.body.classList.add('sidebar-resizing');

    const handleMouseMove = (e: MouseEvent) => {
      const newWidth = Math.max(minWidth, Math.min(maxWidth, e.clientX));
      setWidth(newWidth);
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.body.classList.remove('sidebar-resizing');
      localStorage.setItem(STORAGE_KEY, width.toString());
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing, minWidth, maxWidth, width]);

  return { width, isResizing, handleMouseDown };
};

